import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const options = { withCredentials: false };

@Injectable({
	providedIn: 'root',
})
export class CustomRestService {
	constructor(private http: HttpClient) {}

	GET(url: string): Observable<any> {
		return this.http.get(url, options).pipe(
			map((response: any) => {
				return response;
			})
		);
	}

	POST(url: string, data: any): Observable<any> {
		return this.http.post(url, data).pipe(
			map((response: any) => {
				return response;
			})
		);
	}

	getRateConfirmationPdf(url: string): Observable<any> {
		const headers = { 'Content-type': 'application/pdf', responseType: 'arraybuffer' as 'json' };
		return this.http.get(url, headers).pipe(
			map((response: any) => {
				return response;
			})
		);
	}

	uploadCsvFileToS3(url: string, file: File): Observable<any> {
		const headers = new HttpHeaders({ 'Content-type': file.type });
		return this.http.put(url, file, { headers });
	}

	PUT(url: string, data: any): Observable<any> {
		return this.http.put(url, data).pipe(
			map((response: any) => {
				return response;
			})
		);
	}

	postCarrierPacketsForm(url: string, formData: any): Observable<any> {
		let body = new URLSearchParams();
		body.set('username', formData.username);
		body.set('password', formData.password);
		return this.http.post(url, body);
	}
}
